import * as React from "react";
const DropDownArrow = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 8 5", fill: "currentColor", width: size || "8", height: size || "5", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M7.852.852 4 4.712.146.85a.496.496 0 0 1 .7-.701L4 3.298 7.153.148a.494.494 0 0 1 .699 0l.001.001a.499.499 0 0 1-.001.703Z" }));
DropDownArrow.displayName = "DropDownArrow";
var DropDownArrow_default = DropDownArrow;
export {
  DropDownArrow_default as default
};
